<script>
  // @ts-check
  export let currentRoute = undefined;
  export let links = undefined;
</script>

<ul>
  {#each links as link}
    {@const isCurrentRoute = link.url === currentRoute}
    <li class="[&:not(:last-child)]:pb-3">
      <a
        href={link.url}
        class="transition-color label relative block outline-offset-2 outline-black focus-visible:text-cobalt-blue focus-visible:outline-dashed {isCurrentRoute
          ? 'text-cobalt-blue before:absolute before:left-[-12px] before:top-[50%] before:h-1 before:w-1 before:translate-y-[-50%] before:bg-cobalt-blue'
          : 'hover:text-cobalt-blue'}"
        data-sveltekit-reload
      >
        {link.label}
      </a>
    </li>
  {/each}
</ul>
